import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ManagerPanel, ReviewInfo } from '../timeline-item.types';
import { CommonModule } from '@angular/common';
import { UserInfos } from 'app/frontend/lib/shared/ui/username-icon/user-infos.type';
import { TaskAssignee } from 'app/frontend/lib/taskbook-triage/taskbook.types';
import { MatTooltip } from '@angular/material/tooltip';
import { UsernameIconComponent } from 'app/frontend/lib/shared/ui/username-icon/username-icon.component';

@Component({
    selector: 'tm-manager-panel',
    styleUrls: ['./manager-panel.component.scss'],
    templateUrl: './manager-panel.component.html',
    imports: [
        CommonModule,
        TranslateModule,
        MatTooltip,
        UsernameIconComponent
    ]
})
export class ManagerPanelComponent {

    // @Input({ required: true }) reviewed: ReviewInfo[];

    @Input({ required: true }) managerPanel: ManagerPanel;
    @Input() reviewed: boolean;

    constructor() {}

    protected userInfos(assignee: TaskAssignee): UserInfos {
        return new UserInfos(assignee.firstname, assignee.lastname);
    }
    getTooltipAssigneesContent(assignees: TaskAssignee[]) {
        return assignees.slice(3).map(assignee => `${assignee.firstname} ${assignee.lastname}`).join(', ');
    }

    goToTask(){
        //todo
        console.log('go to task', this.managerPanel.backlogLink);
    }
}